










import Vue from 'vue';
export default Vue.extend({
  name: 'MStoreFormGroup',
  props: {
    label: {
      type: String,
      required: true
    },
    labelFor: {
      type: String
    },
    isRequired: {
      type: Boolean,
      required: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    }
  }
});
